module.exports = __webpack_public_path__ + "img/slide7.e22f8939.png";